<template>
	<div class="relative flex-grow flex">
		<div
			class="px-4 sm:px-6 lg:px-6 py-6 bg-gray-100 flex-grow flex flex-col space-y-2"
		>
			<div
				class="flex-grow flex flex-col justify-center border-2 border-gray-300 border-dashed rounded-lg p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
			>
				<ui-icon
					class="mx-auto h-18 w-18 text-gray-400"
					name="message-square"
					stroke-width="1"
				/>
				<h1 class="mt-2 text-2xl text-gray-400 font-medium">
					{{ __("No negotiations for the current selection") }}
				</h1>
			</div>
		</div>
	</div>
</template>

<script>
export default {};
</script>
